import { createSelector } from '@reduxjs/toolkit'

import { identity } from '../helpers/fp'

const getHabitualResidenceSlice = (state) => state.habitualResidence

export default createSelector([getHabitualResidenceSlice], identity)
